// extracted by mini-css-extract-plugin
export default {"menuBlock":"lI-z","title":"mI-z","nav":"nI-z","flexCell":"oI-z","facetLink":"pI-z"};